module.exports = __webpack_public_path__ + "img/Gb.711534e2.png";